/* eslint-disable parog-web/no-glint-expect-error-directive */
import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import EditionForm from 'parog-web/components/thymic-episode/edition-form';
interface Signature {
  Element: HTMLDivElement;
}
const ThymicEpisode: TOC<Signature> = <template>
  <div class='ui segment [&_.ui.container:not(.fluid)]:!w-auto' ...attributes>
    {{! @glint-expect-error }}
    <h5 class='ui dividing header'>Épisode {{@index}}</h5>

    {{! @glint-expect-error }}
    {{#if @onDestroy}}
      <i
        {{! @glint-expect-error }}
        data-test-destroy-thymic-episode={{@index}}
        class='trash icon absolute right-0 top-0 m-[0.5em] opacity-[0.5]'
        role='button'
        {{! @glint-expect-error }}
        {{on 'click' @onDestroy}}
      >
      </i>
    {{/if}}

    <EditionForm
      {{! @glint-expect-error }}
      @patient={{@patient}}
      {{! @glint-expect-error }}
      @model={{@model}}
      {{! @glint-expect-error }}
      @onChangesetCreated={{@onChangesetCreated}}
      {{! @glint-expect-error }}
      @onChangesetDestroyed={{@onChangesetDestroyed}}
      {{! @glint-expect-error }}
      @hideFooter={{true}}
      @shouldForceQuit={{true}}
      {{! @glint-expect-error }}
      @index={{@index}}
    />
  </div>
</template>;

export default ThymicEpisode;
